<template>
    <div style="text-align: center;">
        <div class="container-fluid" style="max-width:1270px;">
            <h2 class="alternative-styling" style="padding: 22px 0 15px 0;">
                <inertia-link :href="`/${choosenCity.slug}`">{{ title.replace('|MEMBER_CITY|', choosenCity.name) }}</inertia-link>
            </h2>

            <div id="new-campaigns-scroll" class="carousel-4-item swiper-container-with-pagination" v-if="campaigns.length > 0">
                <swiper-slider :key="carouselKey" :breakpoints="{
                    0: { slidesPerView: 2, spaceBetween: 10 },
                    768: { slidesPerView: 4, spaceBetween: 20 },
                    1024: { slidesPerView: 5, spaceBetween:20 },
                }">
                    <swiper-slide v-for="campaign in campaigns" :key="campaign.slug">
                        <campaign-item :campaign="campaign" />
                    </swiper-slide>
                </swiper-slider>
            </div>
        </div>

        <Popper ref="popper" offsetDistance="0">
            <div class="show-all-link" style="padding-bottom: 0px;">
                Byt stad
            </div>

            <template #content>
                <div style="max-height: 200px; overflow: scroll; overflow-x: hidden;">
                    <ul>
                        <li v-for="city in $page.props.cities" style="padding: 2px;" :class="{ 'city-selected': (choosenCity.id === city.id) }">
                            <span v-on:click="chooseCity(city)">{{ city.name }}</span>
                        </li>
                    </ul>
                </div>
            </template>
        </Popper>

        <!-- <inertia-link v-if="choosenCity" :href="`/${$page.props.currentCity.slug}`" class="show-all-link">{{ $t('show_all') }}</inertia-link> -->
    </div>
</template>

<script>
import Popper from 'vue3-popper';
import { SwiperSlide } from 'swiper/vue';
import SwiperSlider from '@/components/Swiper';

export default {
    props: ['title'],

    components: {
        SwiperSlider, SwiperSlide, Popper
    },

    computed: {
        currentUser() {
            return this.$page.props.currentUser;
        }
    },

    data () {
        return {
            user: null,
            showAll: null,
            choosenCity: { name: null },
            campaigns: [],
            carouselKey: 0,
        }
    },

    mounted () {
        this.choosenCity = this.getChoosenCity();
        this.getCampaigns();

        if (this.currentUser && this.currentUser.city) {
            this.showAll = { name: 'city-campaigns', params: { city_slug: this.currentUser.city.slug } };
        }

        // this.$events.$on('login', () => {
        //     this.choosenCity = this.getChoosenCity();
        //     this.getCampaigns();
        // });
    },

    methods: {
        getCampaigns () {
            let url = `/api/startpage/local-heroes`;

            if (this.choosenCity) {
                url += `?city=${this.choosenCity.id}`;
            }

            axios.get(url).then(response => {
                this.campaigns = response.data;
                this.carouselKey = this.carouselKey + 1;
            });
        },

        chooseCity (city) {
            const now = new Date();
            const ttl = 14400000; // (4 * 60 * 60 * 1000) = 4h

            const item = { value: city, expire_at: now.getTime() + ttl };

            localStorage.setItem('fk:local_heroes_city', JSON.stringify(item));
            this.choosenCity = city;

            this.$refs.popper.close();

            this.getCampaigns();
        },

        getChoosenCity () {
            const itemStr = localStorage.getItem('fk:local_heroes_city')

            if (!itemStr) {
                if (this.currentUser && this.currentUser.city) {
                    return this.currentUser.city;
                } else {
                    return { id: 18, name: 'Göteborg', slug: 'goteborg' };
                }
            }

            const item = JSON.parse(itemStr)
            const now = new Date()

            if (now.getTime() > item.expire_at) {
                localStorage.removeItem('fk:local_heroes_city')
                if (this.currentUser && this.currentUser.city) {
                    return this.currentUser.city;
                } else {
                    return { id: 18, name: 'Göteborg', slug: 'goteborg' };
                }
            }

            return item.value
        }
    }
}
</script>
